module.exports = __webpack_public_path__ + "img/nms-demo4.c85847bb.png";